module.exports = __webpack_public_path__ + "static/media/brand-1.a73bd2cc.svg";